import { ShieldCheck } from 'lucide-react';
import { Navigate } from 'react-router';
import { useSession } from '@/entities/session/hooks/use-session';
import { useTranslation } from '@/shared/i18n/use-translation';
import { Card } from '@/shared/ui/card/card';
import { CardContent } from '@/shared/ui/card/card-content';
import { CardDescription } from '@/shared/ui/card/card-description';
import { CardHeader } from '@/shared/ui/card/card-header';
import { CardTitle } from '@/shared/ui/card/card-title';
import { LoginForm } from './login-form';

export function LoginCard() {
  const session = useSession();
  const { t } = useTranslation();
  if (session && !session.expired) return <Navigate to="/" replace />;
  return (
    <Card className="w-full max-w-sm">
      <CardHeader className="items-center text-center">
        <span className="mx-auto mb-2 flex size-12 items-center justify-center rounded-xl bg-primary text-primary-foreground shadow">
          <ShieldCheck className="size-6" />
        </span>
        <CardTitle className="text-xl">{t('Survival kit')}</CardTitle>
        <CardDescription>
          {session?.expired
            ? t('Your session has expired. Sign in again to keep syncing.')
            : t('Sign in with your account.')}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <LoginForm login={session?.user.email_address || session?.user.username} />
      </CardContent>
    </Card>
  );
}
